import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'c-delete-confirm-dialog',
  templateUrl: './delete-confirm-dialog.component.html',
  styleUrls: ['./delete-confirm-dialog.component.scss']
})
export class DeleteConfirmDialogComponent implements OnInit, OnDestroy {
  @Output() confirm: EventEmitter<'one' | 'all' | 'cancel'> = new EventEmitter();
  @Input() message: string;
  @Input() oneButtonLabel = 'Excluir Esta';
  @Input() allButtonLabel = 'Excluir Todas';
  private subscription: Subscription;

  readonly destroy: () => void;
  readonly beforeDestroy = (from: 'container' | 'content' | 'outside') => from != 'content' && this.confirm.next('cancel');

  constructor() { }

  ngOnInit() {
    this.subscription = this.confirm.pipe(
      first()
    ).subscribe(() => {
      this.destroy();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
